import {Component} from '@angular/core';


@Component({
    selector: 'inactive-route-dialog',
    templateUrl: 'inactive-route.dialog.component.html'
})
export class InactiveRouteDialogComponent {
    constructor() {}
}
